/* tslint:disable */
/* eslint-disable */
/**
 * Hyper-Timesheet.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PersonaleResponseDTO
 */
export interface PersonaleResponseDTO {
    /**
     * 
     * @type {number}
     * @memberof PersonaleResponseDTO
     */
    idPersonale?: number;
    /**
     * 
     * @type {string}
     * @memberof PersonaleResponseDTO
     */
    nome?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PersonaleResponseDTO
     */
    cognome?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PersonaleResponseDTO
     */
    descrizione?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PersonaleResponseDTO
     */
    email?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof PersonaleResponseDTO
     */
    isAdmin?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PersonaleResponseDTO
     */
    isSupervisore?: boolean;
}

/**
 * Check if a given object implements the PersonaleResponseDTO interface.
 */
export function instanceOfPersonaleResponseDTO(value: object): value is PersonaleResponseDTO {
    return true;
}

export function PersonaleResponseDTOFromJSON(json: any): PersonaleResponseDTO {
    return PersonaleResponseDTOFromJSONTyped(json, false);
}

export function PersonaleResponseDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): PersonaleResponseDTO {
    if (json == null) {
        return json;
    }
    return {
        
        'idPersonale': json['idPersonale'] == null ? undefined : json['idPersonale'],
        'nome': json['nome'] == null ? undefined : json['nome'],
        'cognome': json['cognome'] == null ? undefined : json['cognome'],
        'descrizione': json['descrizione'] == null ? undefined : json['descrizione'],
        'email': json['email'] == null ? undefined : json['email'],
        'isAdmin': json['isAdmin'] == null ? undefined : json['isAdmin'],
        'isSupervisore': json['isSupervisore'] == null ? undefined : json['isSupervisore'],
    };
}

export function PersonaleResponseDTOToJSON(json: any): PersonaleResponseDTO {
    return PersonaleResponseDTOToJSONTyped(json, false);
}

export function PersonaleResponseDTOToJSONTyped(value?: PersonaleResponseDTO | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'idPersonale': value['idPersonale'],
        'nome': value['nome'],
        'cognome': value['cognome'],
        'descrizione': value['descrizione'],
        'email': value['email'],
        'isAdmin': value['isAdmin'],
        'isSupervisore': value['isSupervisore'],
    };
}

